import { useMediaQuery } from '@mui/material'

export const useMediaMax1025px = () => {
  const MAX_WIDTH = '1025px'
  const isMediaMax1025px = useMediaQuery(`(max-width : ${MAX_WIDTH})`)
  return isMediaMax1025px
}
